import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Rating from '@material-ui/lab/Rating';
import Button from '@material-ui/core/Button';

import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';

import { LandingPageData } from '../types';

import Container from './Container';
import IntroCard from './IntroCards';


const Intro = (props: LandingPageData) => {
  const data = useStaticQuery(graphql`
    query {
      mainImageGatsby: file(relativePath: { eq: "Main-image.png" }) {
        childImageSharp {
          fluid(maxWidth: 1500) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `);

  const setImageName = props?.mainImage?.replace('/img/','') || 'Main-image.png';

  const imagePath = require(`../assets/images/${setImageName}`).default;

  return (
    <div className="intro-wrapper" id="intro">
      <Container>
        <Grid container>
          <Grid item sm={6} xs={12} className="left-column">
            <h1 className="intro-heading">{props.mainHeading}</h1>
            <h2 className="intro-description medium-font">
              {props.mainDescription}
            </h2>
            <div className="button-wrapper">
              <Button
                className="left-button red-button medium-font"
                id = "start-recording-button"
                variant="contained"
                href="https://screenapp.io/#/recording"
              >
                Start recording
              </Button>
              <Button
                className="black-outline-button medium-font"
                id = "read-the-guide-button"
                variant="outlined"
                href="https://screenapp.io/blog/guides.html"
              >
                Read the guide
              </Button>
            </div>
          </Grid>
          <Grid item sm={6} xs={12} justifyContent="center" alignItems="center" style={{ display: 'flex' }} >
            <img src={imagePath} alt="main-image" />
           {/* <Img
              fluid={data.mainImageGatsby.childImageSharp.fluid}
              alt={props.mainHeading}
            /> */}
          </Grid>
        </Grid>
        <Grid container className="bottom-row">
          <Grid item sm={6} xs={12} className="left-column">
            <Grid container className="cards-wrapper">
              <Grid item sm={4} xs={12}>
                <IntroCard
                  headingBlack="200,000"
                  body="Successful Recordings Every month"
                />
              </Grid>
              <Grid item sm={4} xs={12}>
                <IntroCard
                  headingBlack="Reviews"
                  body={<Rating readOnly name="simple-controlled" value={5} />}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item sm={6} xs={12}>
            <Grid container className="cards-wrapper">
              <Grid item sm={4} xs={12}>
                <IntroCard
                  headingRed="100%"
                  headingBlack="Free"
                  body="No registration or Payment required"
                />
              </Grid>
              <Grid item sm={4} xs={12}>
                <IntroCard
                  headingRed="Instant"
                  headingBlack="Recording"
                  body="No software downloads or extensions"
                />
              </Grid>
              <Grid item sm={4} xs={12}>
                <IntroCard
                  headingRed="Quick"
                  headingBlack="Download"
                  body="Save recordings to your computer within Seconds"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

Intro.propTypes = {
  mainHeading: PropTypes.string,
  mainDescription: PropTypes.string,
};

export default Intro;
